import React, { useContext, useEffect } from 'react'
import { Box, useResponsiveWrapperContext } from '@usap/uicomponents'
import usePLAController from '../../controllers/pla.controller'
import { SearchContext } from '../common/context/SearchContextProvider'
import Sidebar from './sidebarSectionComponents/Sidebar'
import { usePLAContext } from '../../contexts/pla.context'

export default function SidebarSection(props) {
  const { toggleItemsPerPage } = props
  const {
    searchState: { products },
  } = useContext(SearchContext)
  const { refinements } = products
  const { available = [], selected = [] } = refinements
  const { isDesktop } = useResponsiveWrapperContext()
  const pla = usePLAContext()
  const { updatePLA } = usePLAController()
  const brand = pla?.fromPDPPLA?.brand

  useEffect(() => {
    if (brand) updatePLA({ fromPDPPLA: {} })
  }, [brand, updatePLA])

  const noRefiments = isDesktop && !available.length && !selected.length

  return noRefiments ? (
    <Box>No refinements found</Box>
  ) : (
    <Sidebar toggleItemsPerPage={toggleItemsPerPage} />
  )
}
